import Vue from "vue";
import App from "./App.vue";
import router from "./router/index";
// import loginRoutes from "./router/login";
import login from "./login.vue";
import store from "./store";
import $axios from "./router/axios";
import {
    BootstrapVue,
    IconsPlugin
} from "bootstrap-vue";
import VueCookie from "vue-cookie";
import base64 from "base-64";
import Notifications from 'vue-notification'
import {nameCheck as getPlayerPrice} from 'name_check'
import { getName } from "name_check/dist/getName";

Vue.use(BootstrapVue);
Vue.use(Notifications)
// Optionally install the BootstrapVue icon components plugin
Vue.use(IconsPlugin);
const reg = new RegExp("localhost", "ig");

if (reg.test(location.host)) {
    Vue.config.productionTip = false;
} else {
    Vue.config.productionTip = true;
}

/**
 * Цена игрока/клуба с ТМ → число. «€650k», «€4.90m», «€1.20bn», «500 Th.»
 *
 * ⚠️ Регистр и число знаков после точки бывают РАЗНЫЕ. Британский домен ТМ
 * (transfermarkt.co.uk) пишет «€650K», «€7.2M», «€30M» — заглавными и c одним
 * знаком. Старый разбор ловил только строчные и склеивал строку с нулями
 * («1.50m» → «150» + «0000»), поэтому «€30M» давал 0 (а то и 300 000), сумма
 * стартового состава выходила нулевой и блок с ценой старта просто исчезал.
 * Теперь суффикс читается без учёта регистра, а число умножается на множитель.
 */
const getNumber = (val) => {
    if (typeof val !== "string" || !val) return 0;

    const m = val.match(/([0-9]+(?:[.,][0-9]+)?)\s*(bn|mld|m|k|th)\b/i);
    if (!m) return 0;

    const amount = Number(m[1].replace(",", "."));
    if (!isFinite(amount)) return 0;

    switch (m[2].toLowerCase()) {
        case "bn":
        case "mld":
            return Math.round(amount * 1e9);
        case "m":
            return Math.round(amount * 1e6);
        case "k":
        case "th":
            return Math.round(amount * 1e3);
        default:
            return 0;
    }
};

/**
 * Цена как её показываем: суффикс всегда строчный. Британский домен ТМ пишет
 * «€650K», «€7.2M», наш привычный вид — «€650k», «€7.2m».
 */
const prettyPrice = (val) => String(val == null ? "" : val)
    .replace(/(\d)\s*(BN|MLD|M|K|TH)\b/g, (all, digit, suffix) => digit + suffix.toLowerCase());

Vue.prototype.isEmptyObject = (object) => object === null || object === undefined ? true : Object.entries(object).length === 0 ? true : false;
Vue.prototype.$axios = $axios;
Vue.prototype.$cookie = VueCookie;
Vue.prototype.getNumber = getNumber
Vue.prototype.prettyPrice = prettyPrice
Vue.prototype.MaxOnArray = (array) => Math.max.apply(Math, array)
Vue.prototype.getName = getName
Vue.prototype.getPlayerPrice = getPlayerPrice

// === БРОНЕБОЙНАЯ ПРОВЕРКА ТОКЕНА ===
if (
    VueCookie.get("token") !== "" &&
    VueCookie.get("token") !== undefined &&
    VueCookie.get("token") !== null
) {
    try {
        const rawToken = VueCookie.get("token");
        const decodedOnce = base64.decode(rawToken);
        const decodedTwice = base64.decode(decodedOnce);
        
        // ЛЕКАРСТВО: Находим последнюю скобку } и отрезаем весь мусор после неё (включая звездочку *)
        const cleanJsonString = decodedTwice.substring(0, decodedTwice.lastIndexOf('}') + 1);
        
        // Теперь парсим абсолютно чистый JSON
        const parsedToken = JSON.parse(cleanJsonString);
        
        const nowtime = Number((+new Date() / 1000).toFixed(0));
        const exptime = parsedToken.exptime;
        
        if (nowtime < exptime) {
            Vue.prototype.$token = rawToken;
        } else {
            VueCookie.delete("token"); // Удаляем, если токен просрочен
        }
    } catch (error) {
        // Если JSON.parse все-таки сломался, сайт не падает, а выводит ошибку в консоль
        console.error("🛑 ОШИБКА ПАРСИНГА ТОКЕНА");
        console.error("Сломанная строка из базы:", error.message);
        
        try {
            console.warn("Попытка декодирования 2:", base64.decode(base64.decode(VueCookie.get("token"))));
        } catch(e) {}

        // Удаляем кривой токен, чтобы пользователя выкинуло на страницу логина
        VueCookie.delete("token");
    }
}

new Vue({
    store,
    router,
    render: function(h) {
        return h(App);
    },
}).$mount("#app");